import React, { useState, useEffect } from 'react'
import PieChart from '../chart/PieChart';
import DataTable from "react-data-table-component";
import { Button } from 'react-bootstrap';
import NCValidationModal from '../modal/NCValidationModal';
import MaterialInspectionReporModal from '../modal/MaterialInspectionReporModal';
import MaterialInspectionReporModalDetails from '../modal/MaterialInspectionReporModalDetails'
import MaterialInspectionRejected from '../modal/MaterialInspectionRejected';
import MaterialWastageReporModal from '../modal/MaterialWastageReporModal'
import CorrectiveActionReportModal from '../modal/CorrectiveActionReportModal'
import { CheckCircleFill, ExclamationTriangleFill } from "react-bootstrap-icons";
import WastageReportModalDetails from "../modal/WastageReportModalDetails"
import DetailedNCReport from '../modal/DetailedNCReport';
import NcReportView from '../modal/NcReportView'
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate"
import Loader from "../loader/Loader"
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
    },
  },
};
export default function NcQuality() {
  const [detailencReport, setDetailencReport] = useState(false)
  const [nCValidation, setNCValidation] = useState(false)
  const [materialInspectionRepor, setMaterialInspectionRepor] = useState(false)
  const [materialInspectionReporModalDetails, setMaterialInspectionReporModalDetails] = useState(false)
  const [materialInspectionRejected, setMaterialInspectionRejected] = useState(false)
  const [materialWastageRepor, setMaterialWastageRepor] = useState(false)
  const [correctiveActionReport, setCorrectiveActionReport] = useState(false)
  const [wastageReportModalDetails, setWastageReportModalDetails] = useState(false)
  const [ncreport, setNcReport] = useState([])
  const [wastageLogs, setWastageLogs] = useState([])
  const [ncVerification, setNcVerification] = useState([])
  const [nspectionreports, setNspectionreports] = useState([])
  const [loading, setLoading] = useState(false);
  const [wastageId, setWastageId] = useState(null)
  const [materialId, setMaterialId] = useState(null)
  const [verifyId, setVerifyId] = useState(null)
  const [nccategories, setNccategories] = useState([])
  const [nchistorymanager, setNchistorymanager] = useState([])
  const [ncReportView, setNcReportView] = useState(false)
  const [ncReportId, setNcReportId] = useState(null)
  const fetchiNCReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/ncstatusoverviewdata`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response.data;
      if (result?.success) {
        setNcReport(result || []);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchNchistorymanager = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/nchistorymanager`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response.data;
      if (result?.success) {
        setNchistorymanager(result?.nchistorymanager || []);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchWastageLogs = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/wastagelogs`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setWastageLogs(result?.wastagelogs || []);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchWastageLogs", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchNcVerification = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/ncreportsverification`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result?.success === true) {
        setNcVerification(result.ncs || []);
      } else {
        setNcVerification([]);
        console.warn(result?.message || "API success false");
      }

    } catch (err) {
      console.error("Error fetching NC Verification", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchNspectionreports = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/materialinspectionreports`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result?.success === true) {
        setNspectionreports(result.materialnc || []);
      } else {
        setNspectionreports([]);
        console.warn(result?.message || "API success false");
      }

    } catch (err) {
      console.error("Error fetching NC Verification", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchiNCReport();
    fetchWastageLogs();
    fetchNcVerification();
    fetchNspectionreports();
    fetchNccategories();
    fetchNchistorymanager()
  }, [])
  const fetchNccategories = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/nccategories`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result?.success === true) {
        setNccategories(result?.ncstatus || []);
      } else {
        setNccategories([]);
        console.warn(result?.message || "API success false");
      }

    } catch (err) {
      console.error("Error fetching NC Verification", err);
    } finally {
      setLoading(false);
    }
  };
  const colors = [
    "#264bdd",
    "#3d78b4",
    "#9fc9fa",
    "#cfe4fb",
    "#e8f1fc",
  ];
  const Nccategories = {
    labels: nccategories?.map((item) => item?.reason),
    datasets: [
      {
        data: nccategories?.map((item) => item?.nc_number),
        backgroundColor: colors.slice(0, nccategories?.data?.length),
        borderWidth: 0,
      },
    ],
  };

  const ncColumns = [
    { name: "Product", selector: row => row?.product?.name, sortable: true, wrap: true, grow: 2 },
    { name: "Type", selector: row => row?.reason, wrap: true, grow: 2 },
    { name: "Reported By", selector: row => row?.user?.name ?? "Johan" },
    { name: "Date", selector: row => formatDate(row?.created_at), },
    {
      name: "Status",
      cell: row => (
        <span
          className={`badge ${row?.status === "New"
            ? "bg-primary-subtle text-dark"
            : "bg-danger-subtle text-dark"
            } p-2`}
        >
          {row?.status}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: row => (
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => { handleAction(row); setVerifyId(row?.id) }}
        >
          Verify Effectiveness
        </Button>

      ), width: "180px"
    },
  ];

  const managerColumns = [
    { name: "Product", selector: row => row?.product?.name, sortable: true, wrap: true, grow: 2 },
    { name: "Type", selector: row => row?.reason, wrap: true, grow: 2 },
    { name: "Reported By", selector: row => row?.user?.name ?? "Johan" },
    { name: "Date", selector: row => formatDate(row?.created_at), },
    {
      name: "Status",
      cell: row => (
        <span
          className="p-2 bg-success-subtle text-success"
        >
          {row?.status}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => (setNcReportView(true), setNcReportId(row?.id))}
        >
          View Details
        </button>
      ),
    },
  ];
  const handleAction = (row) => {
    if (row.status === "New" || row.status === "Inprogress") {
      setNCValidation(true)
    } else if (row.status === "Resolved") {
      setCorrectiveActionReport(true)
    }
  };
  const getResultByStatus = (status) => {

    if (["open", "inprogress", "closed"].includes(status)) {
      return "Accepted";
    }

    if (status === "escalated") {
      return "Rejected";
    }

    return "-";
  };

 const getResultBadge = (decision) => {
  if (!decision) return null;

  const value = decision.toLowerCase();
  let className = "bg-secondary-subtle text-dark";
  if (value === "approved") {
    className = "bg-success-subtle text-success";
  }
  else if (value === "rejected") {
    className = "bg-danger-subtle text-danger";
  }
  else if (value === "hold") {
    className = "bg-warning-subtle text-warning";
  }

  return (
    <span className={`badge ${className} px-3 py-2`}>
      {decision}
    </span>
  );
};

  const getStatusIcon = (decision) => {
    return decision === "hold" ? (
      <ExclamationTriangleFill className="text-danger fs-5" />
    ) : (
      <CheckCircleFill className="text-success fs-5" />
    );
  };

  // const handleActionClick = (row) => {
  //   const decision = row.decision?.toLowerCase();
  //   const result = getResultByStatus(decision);

  //   if (decision === "hold") {
  //     setMaterialInspectionRepor(true);
  //   }
  //   else if (result === "Approved") {
  //     setMaterialInspectionReporModalDetails(true);
  //   }
  //   // else if (result === "Rejected") {
  //   //   setMaterialInspectionRejected(true);
  //   // }
  // };
  
  const handleActionClick = (row) => {
  const decision = row?.decision?.toLowerCase();

  if (decision === "hold") {
    setMaterialInspectionRepor(true);
  } 
  else if (decision === "approved" || decision === "rejected") {
    setMaterialInspectionReporModalDetails(true);
  }
};

  const Mcolumns = [
    { name: "ID", selector: (row) => row?.material_master?.material_code, sortable: true },
    { name: "MATERIAL", selector: (row) => row?.material_master?.material_name },
    { name: "SUPPLIER", selector: (row) => row?.supplier_name ?? "DPM" },
    // { name: "INSPECTED BY", selector: (row) => row.inspectedBy ?? "Supervisor" },
    { name: "DATE", selector: (row) => formatDate(row?.created_at) },
    {
      name: "RESULT",
      cell: (row) => getResultBadge(row?.decision),
    },
    {
      name: "STATUS",
      cell: (row) => getStatusIcon(row?.decision?.toLowerCase()),
    },
    {
      name: "ACTIONS",
      cell: (row) => {
        const decision = row?.decision?.toLowerCase();

        return (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => { handleActionClick(row); setMaterialId(row.id); }}
            style={{ whiteSpace: "nowrap" }}
          >
            {decision === "hold" ? "Verify" : "View Details"}
          </Button>
        );
      },
    }

  ];


  const getVerifiedIcons = (status) => {
    const normalizedStatus = status?.toLowerCase();
    return normalizedStatus === "pending" ? (
      <ExclamationTriangleFill className="text-danger fs-5" />

    ) : (
      <CheckCircleFill className="text-success fs-5" />
    );
  };

  const handleActionClicks = (row) => {
    const normalizedStatus = row.status?.toLowerCase();
    if (normalizedStatus === "pending") {
      setMaterialWastageRepor(true);
    } else {
      setWastageReportModalDetails(true);

    }
  };
  const Wcolumns = [
    { name: "ID", selector: (row) => row?.material_master?.material_code, sortable: true },
    { name: "MATERIAL", selector: (row) => row?.material_master?.material_name },
    { name: "QUANTITY", selector: (row) => row?.quantity },
    { name: "REPORTED BY", selector: (row) => row?.reported_by?.name },
    { name: "DATE", selector: (row) => formatDate(row?.created_at) },
    { name: "REASON", cell: (row) => row?.reason },
    {
      name: "STATUS",
      cell: (row) => getVerifiedIcons(row.status),
    },
    {
      name: "ACTIONS",
      cell: (row) => {
        const normalizedStatus = row.status?.toLowerCase();
        const isPending = normalizedStatus === "pending";
        return (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => { handleActionClicks(row); setWastageId(row.id); }}
            style={{ whiteSpace: "nowrap" }}
          >
            {isPending ? "Verify" : "View Details"}
          </Button>
        );
      },
    },
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="row g-4 font_family">
        <div className="col-12 col-md-6">
          <div className="p-3 border rounded bg-light h-100">
            <strong className='fs-4'>NC Categories</strong>
            <PieChart pieChart={Nccategories} />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="p-3 border rounded bg-light font_family h-100">
            {
              loading ? (
                <Loader />
              ) : (
                <>
                  <h5 className="fw-bold mb-3">NC Status Overview</h5>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <span className="text-muted">Total NCs This Month</span>
                    <span className="fs-5 fw-bold">{ncreport?.totalncinmonth}</span>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">New</div>
                        <div className="fw-bold text-danger fs-5">{ncreport?.totalopenncinmonth}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">In Progress</div>
                        <div className="fw-bold text-warning fs-5">{ncreport?.totalinprogressncinmonth}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">Resolved</div>
                        <div className="fw-bold text-success fs-5">{ncreport?.totalreslovedncinmonth}</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="border rounded p-3 text-center h-100">
                        <div className="text-muted">Escalated</div>
                        <div className="fw-bold text-primary fs-5">{ncreport?.totalesclatedncinmonth}</div>
                      </div>
                    </div>
                  </div>

                  {/* <button className="btn btn-dark  w-100" onClick={() => setDetailencReport(true)}>
              View Detailed NC Report
            </button> */}
                </>
              )
            }
          </div>
        </div>
      </div>
      {/* Escalated Issuse */}
      {/* <div className="row mt-4">
        <div className="col-md-12 mb-2">
          <div className="card font_family">
            <strong className='p-2 fs-4'>Escalated Issuse</strong>
            <div className='shadow-sm mt-2 p-2'>
              {planningActions.map((action, index) => (
                <div key={index} className={`mb-3 border-${action.color} bg-${action.color} bg-opacity-10 border-start border-4 border-${action.color} `}>
                  <Card.Body>
                    <h6 className={`text-${action.color} fw-bold`}>
                      <span className="me-2">{action.icon}</span>{action.title}
                    </h6>
                    <p>{action.description}</p>
                    {action.buttons.map((btn, i) => (
                      <Button
                        key={i}
                        variant={i % 2 === 0 ? `light` : 'dark'}
                        size="sm"
                        className="me-2 mb-1"
                      >
                        {btn}
                      </Button>
                    ))}
                  </Card.Body>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div> */}
      {/* Nc Reports Verification */}
      <div className='row mt-3'>
        <div className="col-md-12 mb-2">
          <div className='card'>

            <div className='shadow-sm p-2'>
              <strong className='fs-4'>NC Reports Verification</strong>
              {
                loading ? (
                  <Loader />
                ) : (
                  <DataTable
                    columns={ncColumns}
                    data={ncVerification}
                    highlightOnHover
                    customStyles={customStyles}
                    responsive
                    striped
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-3'>
        <div className="col-md-12 mb-2">
          <div className='card'>

            <div className='shadow-sm p-2'>
              <strong className='fs-4'>NC Reports Verification History</strong>
              {
                loading ? (
                  <Loader />
                ) : (
                  <DataTable
                    columns={managerColumns}
                    data={nchistorymanager}
                    highlightOnHover
                    customStyles={customStyles}
                    responsive
                    striped
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>

      {/* { Material list} */}
      <div className='row mt-4 m-1'>
        <div className='card p-3'>
          <div className=" justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Material Inspection Reports</strong>
          </div>
          {
            loading ? (
              <Loader />
            ) : (
              <DataTable
                columns={Mcolumns}
                data={nspectionreports}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
              />
            )
          }
        </div>
      </div>

      {/* { Wastage list} */}
      <div className='row mt-4 m-1'>
        <div className='card p-3'>
          <div className=" justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Wastage Logs</strong>
          </div>
          {
            loading ? (
              <Loader />
            ) : (

              <DataTable
                columns={Wcolumns}
                customStyles={customStyles}
                data={wastageLogs}
                responsive
                striped
                highlightOnHover
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
              />
            )
          }
        </div>
      </div>
      {/* <button onClick={() => setNCValidation(true)} className='btn btn-dark mt-3'>Nc Validation</button><br /> */}
      {/* NCValidationModal */}
      <NCValidationModal
        verifyId={verifyId}
        show={nCValidation}
        refreshParent={() => {
          fetchNcVerification();
          fetchNchistorymanager();
        }}
        handleClose={() => setNCValidation(false)}
      />
      {/* MaterialInspectionReporModal */}
      <MaterialInspectionReporModal
        materialId={materialId}
        show={materialInspectionRepor}
        refreshParent={fetchNspectionreports}
        handleClose={() => setMaterialInspectionRepor(false)}
      />
      {/* MaterialInspectionRejected */}
      <MaterialInspectionRejected
        show={materialInspectionRejected}
        handleClose={() => setMaterialInspectionRejected(false)}
      />
      {/* MaterialWastageReporModal */}
      <MaterialWastageReporModal
        wastageId={wastageId}
        show={materialWastageRepor}
        handleClose={() => setMaterialWastageRepor(false)}
      />
      {/* CorrectiveActionReportModal */}
      <CorrectiveActionReportModal
        show={correctiveActionReport}
        handleClose={() => setCorrectiveActionReport(false)}
      />
      <DetailedNCReport
        show={detailencReport}
        handleClose={() => setDetailencReport(false)}
      />
      <MaterialInspectionReporModalDetails
        materialId={materialId}
        show={materialInspectionReporModalDetails}
        handleClose={() => setMaterialInspectionReporModalDetails(false)}
      />
      <WastageReportModalDetails
        wastageId={wastageId}
        show={wastageReportModalDetails}
        handleClose={() => setWastageReportModalDetails(false)}
      />
      <NcReportView
        ncReportId={ncReportId}
        show={ncReportView}
        handleClose={() => setNcReportView(false)}
      />
    </div>
  )
}
